import '@/assets/main.scss'
import 'ant-design-vue/dist/reset.css'
import { createApp } from 'vue'
import App from '@/App.vue'
import { createPinia } from 'pinia'
import router from '@/router'
import Antd from 'ant-design-vue'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router())
app.use(Antd)
app.mount('#app')

const domainManager = Array.from({ length: parseInt(process.env.VUE_APP_DOMAIN_COUNT as string) }, (_, i) => ({
	domain: process.env[`VUE_APP_DOMAIN_${i}`],
	title: process.env[`VUE_APP_DOMAIN_TITLE_${i}`]
}))

const currentHost = window.location.hostname
const matched = domainManager.find(i => currentHost.includes(i.domain))

document.title = matched?.title || domainManager[0]?.title
